import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import {Backdrop,CircularProgress,Snackbar, makeStyles, Typography} from '@material-ui/core'
import Alert from '@material-ui/lab/Alert';
const useStyle=makeStyles((theme) => ({
  
}))
const Page = forwardRef(({ children, title = '',cargando,mensaje, ...rest }, ref) => {
  const classes=useStyle();
  return (
    <div
      ref={ref}
      {...rest}
    >
      <Snackbar open={mensaje.open} autoHideDuration={4000} onClose={mensaje.cerrar}>
        <Alert onClose={mensaje.cerrar} variant="filled" severity={mensaje.status<0?'error':mensaje.status>0?'success':'info'}>
          {mensaje.value}
        </Alert>
      </Snackbar>
      <Backdrop id="cargando" open={cargando}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Helmet>
        <title> SYS ~ {title}</title>
      </Helmet>
      {children}
      
    </div>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  cargando:PropTypes.bool,
  mensaje:PropTypes.object,
};
Page.defaultProps={
  cargando:false,
  mensaje:{
    open:false,
    value:'',
    status:0,
    cerrar:()=>{}
  }
}
export default Page;
